import arrow from "../../images/arrow-1.svg"
import "./skills.css"

function Chip({ text }) {
    return (
        <div className="chip">
            <p className="chip-text">{text}</p>
        </div>
    )
}

export default function Skills() {
    const skills = [
        'C/C++',
        'Java',
        'Python',
        'JavaScript',
        'PHP',
        'SQL',
        'Flutter',
        'React.js',
        'Node.js',
        'Express.js',
        'MongoDB',
        'Django',
        'Machine Learning'
    ];

    const skillComponents = skills.map((skill, idx) => <Chip text={skill} key={idx} />)

    return (
        <div className="skills">
            <h2 className="skills-header">Skills</h2>
            <div className="skills-container">{skillComponents}</div>
            <img className="skills-arrow" src={arrow} alt='arrow' />
        </div>
    )
}